export enum TrackingItemType {
  Added = 'added',
  Removed = 'removed',
  Updated = 'updated'
}
